import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Row.scss'


const Row = ({ children, className, align, justify }) => (
  <div className={cx(s.row, className, {
    [s[`align-${align}`]]: Boolean(align),
    [s[`justify-${justify}`]]: Boolean(justify),
  })}>
    {children}
  </div>
)

Row.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  align: PropTypes.oneOf([ 'center', 'start', 'end', 'baseline' ]),
  justify: PropTypes.oneOf([ 'center', 'start', 'end' ]),
}

Row.defaultProps = {
  align: 'center',
}


export default Row
